var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-centered is-multiline"},[_c('div',{staticClass:"column is-8"},[_c(_vm.currentQuestion,{tag:"component",staticClass:"columns is-multiline",on:{"done":_vm.onStepDone}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }